import axios from 'axios';
import { CLIENTES } from '../constantes';
export const GET_CLIENTES = 'GET_CLIENTES';
export const GET_CLIENTES_ID = 'GET_CLIENTES_ID';
export const POST_CLIENTES = 'POST_CLIENTES';
export const GET_SEARCH = 'GET_SEARCH';
export const PUT_CLIENTE = 'PUT_CLIENTE';



export const getClientes = () => async dispatch => {
    await axios.get(CLIENTES, {withCredentials: true})
        .then((res) => {
            dispatch({
                type: GET_CLIENTES,
                payload: res.data
            })
            //console.log(res.data)
        })
        .catch((err) => {console.log(err)})
}

export const getClientesId = (id) => async dispatch => {
    try {
        await axios.get(`${CLIENTES}/${id}`, {withCredentials:true})
        .then(res => {
            dispatch({
                type: GET_CLIENTES_ID,
                payload: res.data
            })           
        })
    } catch (error) {
        console.log(error)
    }
}

export const postClientes = (payload) => async dispatch => {
    console.log(payload)
    try {
        await axios.post(CLIENTES, payload, {withCredentials:true})
            .then(res => {
                dispatch({
                    type: POST_CLIENTES,
                    payload: res.data
                })
                console.log(res.data)
            })
    } catch (error) {
        return (error)
    }
}

export const putClient = (id, payload) => async dispatch => {
    console.log(id, payload) // "https://sistemaandyback-production.up.railway.app/api/documents/" + id, payload
    try {
        await axios.put(`${CLIENTES}/${id}`, payload, {withCredentials:true})
        .then(res => {
            dispatch({
                type: PUT_CLIENTE,
                payload: res.data
            })
            console.log(res.data)
        })
    } catch (error) {
        return (error)       
    }
}

export const getClientesByName = (name) => async dispatch => {
    try {
        await axios.get(CLIENTES, name, {withCredentials:true})
        .then(res => {
            dispatch({
                type: GET_SEARCH,
                payload: res.data
            })
        })
    } catch (error) {
        return alert("No existe nombre")
    }
}




